import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import {
    Alert,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";
import { DeleteOutline, Close } from "@mui/icons-material";
import { useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks";
import { deleteUrsTeamMember } from "../UrsSlice";

export interface DeleteTeamMemberDialogProps {
    id: AppId;
    userFullName: string;
    onSuccess: () => void;
    onCancel: () => void;
}

export const DeleteTeamMemberDialog = (props: DeleteTeamMemberDialogProps) => {
    const dispatch = useAppDispatch();
    const [pending, setPending] = useState(false);
    const [serverError, setServerError] = useState("");

    const handleOkClick = async () => {
        setPending(true);
        try {
            const result = await dispatch(deleteUrsTeamMember(props.id));
            if (deleteUrsTeamMember.fulfilled.match(result)) {
                props.onSuccess();
            } else {
                // wyciągnij ProblemDetails jeżeli jest
                let msg = "error-team-member-already-done-action";

                setServerError(msg);
            }
        } finally {
            setPending(false);
        }
    };

    return (
        <Dialog open fullWidth maxWidth="xs" onClose={props.onCancel}>
            {/* Header z szarym tłem i ikoną kosza */}
            <DialogTitle
                sx={(t) => ({
                    bgcolor: t.palette.grey[100],
                    py: 1.5,
                    px: 2,
                })}
            >
                <Stack direction="row" alignItems="center" spacing={1.25}>
                    <DeleteOutline fontSize="small" />
                    <Typography >
                        <Localized id="delete-team-member">Usuń członka zespołu</Localized>
                    </Typography>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            variant="subtitle1"
                            noWrap
                            title={props.userFullName}
                            sx={{ fontWeight: 600 }}
                        >
                            {props.userFullName}
                        </Typography>

                    </Box>

                </Stack>
            </DialogTitle>

            {/* Treść */}
            <DialogContent>
                <Localized id="confirm-delete">
                    Czy na pewno chcesz usunąć?
                </Localized>

                {serverError && (
                    <Alert
                        sx={{ mt: 2 }}
                        severity="error"
                        onClose={() => setServerError("")}
                    >
                        <Localized id={serverError}>
                            <span>Wystąpił błąd serwera.</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>

            {/* Akcje */}
            <DialogActions sx={{ px: 2, pb: 2 }}>

                <LoadingButton
                    loading={pending}
                    onClick={handleOkClick}
                    color="error"
                    variant="contained"
                    startIcon={<DeleteOutline />}
                >
                    <Localized id="delete">Usuń</Localized>
                </LoadingButton>
                <LoadingButton
                    loading={pending}
                    onClick={props.onCancel}
                    variant="outlined"
                >
                    <Localized id="close">Zamknij</Localized>
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};
